<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'

    @Component
    export class TourStoreMixin extends Vue {
        get productStore() {
            return toursStore
        }

        get productRuntimeStore() {
            return toursRuntimeStore
        }

        get productType() {
            return 'tour'
        }
    }

    export default TourStoreMixin
</script>
